import React from 'react';
import Card from '../../Card';
import UserPlayer from '../../../entities/players/UserPlayer';
import CardTypes from '../../../constants/CardTypes';
import Constants from '../../../constants/Constants';

export default class CandyAttackCard extends Card {

    onAfterCardThrownFromPlayerToUsedPile = () => {
        this.gameCtx.soundRepository.playSoundByName(this.cardSound);

        let nextPlayerEntity = this.gameCtx.gameSeqHandler.getNextTurnEntity();

        if (nextPlayerEntity instanceof UserPlayer) {
            nextPlayerEntity.subscribePlayMethod(
                this.userPlayerResponseMove,
                Constants.FLAGS_SINGLE_TIME_USE,
                Constants.FLAGS_REPLACE_METHOD
            );
        }
        else {
            nextPlayerEntity.subscribePlayMethod(
                this.computerPlayerResponseMove,
                Constants.FLAGS_SINGLE_TIME_USE,
                Constants.FLAGS_REPLACE_METHOD
            );
        }
    }

    // COMPUTER PLAYER MOVE

    computerPlayerResponseMove = async () => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
        let val = cEntity.hasCardFromType(CardTypes.CABBAGE_BROCCOLI_CARD);

        if (val) { // Notice: If computerPlayer has a protection card, it will always use it
            await this.computerPlayerProtectiveMove();
        }
        else {
            await this.computerPlayerIsAttacked();
        }

        await cEntity.levelToSixCards();
    }

    computerPlayerIsAttacked = async () => {

        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();

        await cEntity.getCardsFromCandyPile(2);

        await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);

        cEntity.excludeCards = { exList: cEntity.getLastReceivedCards(), cb: null };

        cEntity.chooseRandCard(true);

        await this.gameCtx.moveCard(cEntity.entityIndex, Constants.USED_PILE_INDEX, cEntity.chosenCard, true, true);

        await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);

        cEntity.chooseRandCard(true);

        await this.gameCtx.moveCard(cEntity.entityIndex, Constants.USED_PILE_INDEX, cEntity.chosenCard, true, true);

        await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);
    }

    computerPlayerProtectiveMove = async () => {

        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();

        cEntity.includeType = { viType: [CardTypes.CABBAGE_BROCCOLI_CARD], cb: null };

        cEntity.chooseRandCard(false, true);

        await this.gameCtx.moveCard(cEntity.entityIndex, Constants.USED_PILE_INDEX, cEntity.chosenCard, true, true);

        this.gameCtx.soundRepository.pauseSoundByName(this.cardSound);
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_PROTECTION_CARD);
        
        await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);

        await cEntity.getCardsFromNewPile(1);

        await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);
    }

    // USER PLAYER MOVE

    userPlayerResponseMove = async () => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
        let val = cEntity.hasCardFromType(CardTypes.CABBAGE_BROCCOLI_CARD);

        if (val) {
            await this.userPlayerProtectiveMove();
        }
        else {
            await this.informAttack();
            await this.getAndThrowCards();
        }

        await cEntity.levelToSixCards();

        cEntity.resolvePlayerFinal(0);
        return cEntity.userEventComplete;
    }

    informAttack = async () => {
        let text = <div className="popup-text interval-popup-text">הותקפת ב"{this.cardName}"!<br />אין ברשותך קלף הגנה "כרוב-ברוקולי", התכונן לחורים בשיניים!</div>

        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
        cEntity.addPopupWithInterval(text);
        await this.gameCtx.waitFor(Constants.INTERVAL_BEFORE_REMOVE_POPUP);

        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_CARD_POPUP);
    }

    userPlayerProtectiveMove = async () => {

        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();

        let text = <div className="popup-text">הותקפת ב"{this.cardName}"!<br />"האם תרצה להשתמש בקלף הגנה "כרוב-ברוקולי?</div>

        let popupRes = await cEntity.addPopupWithEvent(text);

        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_CARD_POPUP);

        if (popupRes) {
            await this.enableClickingProtectionCard();
        }
        else {
            if (popupRes === false) {
                await this.getAndThrowCards();
            }
            else { // popupRes is undefined due to timer ended
                await this.computerPlayerIsAttacked(); // Notice: User player is attacked as if it was computerPlayer
            }
        }
    }

    getAndThrowCards = async () => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();

        cEntity.setFinalUserEvent();
        await cEntity.getCardsFromCandyPile(2);

        let forbidChoosingCards = cEntity.getLastReceivedCards();
        cEntity.excludeCards = {
            exList: forbidChoosingCards, cb: async () => {
                let text = <div className="popup-text interval-popup-text">אין באפשרותך לזרוק קלף שקיבלת בתור זה.<br />נסה לבחור קלף אחר</div>

                let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
                cEntity.addPopupWithInterval(text);
                await this.gameCtx.waitFor(Constants.INTERVAL_BEFORE_REMOVE_POPUP);

                this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_CARD_POPUP);
            }
        };

        cEntity.addBubbleOnBottomPlayer("זרוק 2 קלפים", Constants.ELEMENT_MY_PLAYER_THROW_A_CARD);
        cEntity.subscribeUserEventToCards((cardObj) => cEntity.handleChooseCardEvent(cardObj, true), Constants.FLAGS_MULTIPLE_TIME_USE);
        await cEntity.waitForEvent();

        await this.gameCtx.moveCard(cEntity.entityIndex, Constants.USED_PILE_INDEX, cEntity.chosenCard, true, true);

        cEntity.subscribeUserEventToCards((cardObj) => cEntity.handleChooseCardEvent(cardObj, true), Constants.FLAGS_MULTIPLE_TIME_USE);
        await cEntity.waitForEvent();

        await this.gameCtx.moveCard(cEntity.entityIndex, Constants.USED_PILE_INDEX, cEntity.chosenCard, true, true);

        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_MY_PLAYER_THROW_A_CARD);
    }

    enableClickingProtectionCard = async () => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
        cEntity.addBubbleOnBottomPlayer("זרוק קלף כרוב-ברוקולי", Constants.ELEMENT_MY_PLAYER_THROW_CABBAGE_BROCCOLI_CARD);
        cEntity.setFinalUserEvent();

        cEntity.includeType = {
            viType: [CardTypes.CABBAGE_BROCCOLI_CARD], cb: async () => {
                let text = <div className="popup-text interval-popup-text">עליך לבחור קלף הגנה<br />"כרוב ברוקולי"!</div>

                let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
                cEntity.addPopupWithInterval(text);
                await this.gameCtx.waitFor(Constants.INTERVAL_BEFORE_REMOVE_POPUP);

                this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_CARD_POPUP);
            }
        };

        cEntity.subscribeUserEventToCards(
            (cardObj) => cEntity.handleChooseCardEvent(cardObj, false, true),
            Constants.FLAGS_MULTIPLE_TIME_USE);

        await cEntity.waitForEvent();

        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_MY_PLAYER_THROW_CABBAGE_BROCCOLI_CARD);

        if (!cEntity.chosenCard) { // If user didn't throw protection card --> Throw automatically protection card
            cEntity.chooseRandCard(false, true);
        }

        await this.gameCtx.moveCard(cEntity.entityIndex, Constants.USED_PILE_INDEX, cEntity.chosenCard, true, true);

        this.gameCtx.soundRepository.pauseSoundByName(this.cardSound);
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_PROTECTION_CARD);

        await cEntity.getCardsFromNewPile(1);

        await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);
    }
}
